import { AfterViewInit, Directive, ElementRef, EventEmitter, inject, Output } from '@angular/core';

@Directive({
  selector: '[qpointAfterViewInitTrigger]',
  standalone: true
})
export class AfterViewInitDirective implements AfterViewInit {
  readonly elementRef = inject(ElementRef);
  @Output() viewInitialized = new EventEmitter<ElementRef<unknown>>();

  ngAfterViewInit() {
    this.viewInitialized.emit(this.elementRef);
  }
}
